<template>
    <div class="subtitle-container">
        <h4 class="subtitle">{{ text }}</h4>
    </div>
</template>
<script>
    export default {
        props: {
            text: {
                type: String,
                required: true
            }
        }
    }
</script>
<style>
    .subtitle {
        color: #2D2461;
    }
</style>